import { observer } from 'mobx-react';

import { InitialStoreSelectorModalTranslation } from '../../../localization/SiteTranslation';
import CustomSelect from '../../../shared/components/CustomSelect/CustomSelect';
import { StoreWithUniqueKey } from '../../StoreSelectionState';
import { CustomMenuListComponent } from '../InitialStoreSelectorModal';
import { InitialStoreSelectorModalState, ISelectItem } from '../InitialStoreSelectorModalState';

interface IInitialStoreSelector {
  modal: InitialStoreSelectorModalState;
  onSelect: (store: ISelectItem) => void;
  translation: InitialStoreSelectorModalTranslation;
}

const getMappedStores = (stores: Array<StoreWithUniqueKey>) => {
  return stores.map((store) => {
    return {
      value: store.key,
      label: store.displayName ? store.displayName : store.name,
    };
  });
};

export const InitialStoreSelector = observer(({ modal, translation, onSelect }: IInitialStoreSelector) => {
  const mappedStores = getMappedStores(modal.storesWithoutGlobal);

  const defaultStoreValue = mappedStores.find((x) => x.value === modal.storeSelection?.currentStore?.key);

  return (
    <CustomSelect
      defaultValue={defaultStoreValue}
      placeholder={translation.inputPlaceholder}
      noOptionsMessage={() => translation.noOptionMessage}
      options={mappedStores}
      onChange={onSelect}
      components={{
        MenuList: CustomMenuListComponent,
      }}
    />
  );
});
